export default {"src":"/_next/static/media/logo-light.4c75647e.svg","height":34,"width":168};